export class Role {
  public id!: string;

  public name!: string;

  constructor(init?: Partial<Role>) {
    Object.assign(this, init);
  }
}
